module.exports = __webpack_public_path__ + "static/3-62b59e98d8cba515f9381fa08dc66681.jpg";